import { track } from '@mc/track-event'

const EVENT_NAME = 'Droppable Quiz Module Viewed'

export const trackDroppableQuizModuleViewed = () => {
  track(EVENT_NAME)
}
